/**
 * This is an error boundary intended to be run as the first child of the React
 * tree, so that if any error bubbles up from within a component, we can present a
 * "something went wrong" message.
 *
 * That also means that an error can come from any of the components that
 * require providers, so none of the code here should reference another
 * component or existing styles.
 */
import React from 'react'

import { DatadogClient } from '#util/datadog'

import brokenTvImage from '../assets/images/TV-broken.png'

import styles from './RootErrorBoundary.module.css'

interface Props extends React.PropsWithChildren {}

interface State {
  error: Error | null
}

export class RootErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    DatadogClient.getInstance().error(
      'Root error boundary caught error',
      { errorInfo },
      error,
    )
  }

  render() {
    if (this.state.error) {
      return (
        <div className={styles.container}>
          <section>
            <img src={brokenTvImage} alt="TV with broken screen" />
            <h1>500</h1>
            <h2>Error</h2>
            <p>Something went wrong and we are looking into it</p>
            <footer>
              <button onClick={() => window.location.reload()}>
                Refresh Page
              </button>
            </footer>
          </section>
        </div>
      )
    }

    return this.props.children
  }
}
